import Swiper, {Autoplay, Navigation, Scrollbar} from "swiper";

const mainSlider = () => {

    // init Swiper:
    const swiper = new Swiper('[data-main-slider]', {
        modules: [Scrollbar, Navigation, Autoplay],
        scrollbar: {
            el: '.main__slider_scrollbar',
            draggable: true,
        },
        simulateTouch: false,
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 24,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.main__slider_next',
            prevEl: '.main__slider_prev',
        },
    });

}

mainSlider()
